<template>
  <div class="material">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>展会设置</BreadcrumbItem>
          <BreadcrumbItem>完成项设置</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">完成项设置</div>
        <!-- <p style="line-height:40px;color:#808080;font-size:12px;">移动端平台展示的分类内容</p> -->
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="add" :disabled-hover="false">
          <span class="htb-add">+</span>
          <span>添加完成项</span>
        </div>
      </div>
    </div>

    <div class="eh-content" v-if="FinishList.length">
      <Row :gutter="30">
        <Col :md="12" :xl="6" :xxl="6" v-for="(item, index) in FinishList" :key="'releaseInt-' + index" class="w-20">
        <!-- 会刊信息 -->
        <div class="pro pro-over">
          <div class="pro-top">{{item.showIndex}} {{item.name}}</div>
          <div class="pro-bot common-bot">
            <p>{{item.introduction}}</p>
            <span class="type-2" v-if="item.stopTime">{{item.stopTime | moment("YYYY/MM/DD") }}截止</span>
            <!-- <span class="type-2">{{'2020年3月24日' | moment("YYYY/MM/DD")}}截止</span> -->
          </div>
          <div class="pro-tool">
            <div class="pro-tool-item" @click="editModal(item)">编辑</div>
            <div class="pro-tool-line"></div>
            <div class="pro-tool-item z-del">
              <Poptip confirm title="您确认删除这条内容吗？" @on-ok="delItem(item)">删除</Poptip>
            </div>
          </div>
        </div>
        </Col>
      </Row>
    </div>

    <emptyList v-else @change="add()"></emptyList>

    <!-- 弹框 -->
    <addModel :show="showModel" :modelTitle="modelTitle" :options="options" @finish="init()" @close="showModel=false"></addModel>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import addModel from "./project-add";
import emptyList from "@components/emptyList/emptyList";

export default {
  name: "project-set",
  data () {
    return {
      showModel: false,
      modelTitle: "",
      options: {},
      FinishList: []
    };
  },
  components: {
    addModel,
    emptyList
  },
  computed: {
    exhibitionInfo () {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
    header () {
      return this.$store.state.header;
    }
  },
  created () {
    this.init();
  },
  methods: {
    ...mapActions({}),
    init () {
      this.getFinishList();
    },
    getFinishList () {
      // 获取展会完成项
      this.$http
        .get(
          `/api/FinishItem/GetFinishItems?exhibitionId=${this.exhibitionInfo.id}`,
          this.header
        )
        .then(res => {
          if (res.status === 200 && res.data) {
            res.data.reverse()
            this.FinishList = res.data;
          }
        });
    },
    add () {
      this.showModel = true;
      this.modelTitle = "新增完成项";
      this.options = {
        msg: null,
        model: null
      };
    },
    editModal (item) {
      this.showModel = true;
      this.modelTitle = "编辑完成项";
      this.options = {
        msg: item,
        model: "edit"
      };
    },
    delItem (item) {
      // 删除
      this.$http
        .delete(`/api/FinishItem?Id=${item.id}`, this.header)
        .then(res => {
          if (res.status === 200 && res.data.successed) {
            this.$Message.success("删除成功！");
            this.init();
          } else {
            this.$Message.error("删除失败，请重新尝试");
          }
        });
    }
  }
};
</script>

<style scoped lang="scss">
.header-tool-utils {
  margin-top: 20px;
  button {
    margin-right: 20px;
  }
}
.eh {
  &-content {
    padding: 24px;
    .pro {
      height: 260px;
      background-color: #fafafa;
      box-shadow: 0px 2px 6px 0px rgba(136, 156, 176, 0.1);
      margin-bottom: 24px;
    }
    .pro-no {
      background-color: #fff;
      .pro-top {
        color: #333;
      }
      .common-bot {
        p {
          color: #333;
        }
      }
    }
    .pro-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 52px;
      font-size: 16px;
      color: #333;
      padding: 0 24px;
      border-bottom: 1px solid #e8e8e8;
      cursor: pointer;
      span {
        display: block;
        color: #009944;
        font-size: 16px;
      }
    }
    .pro-bot {
      padding: 12px 24px 24px 24px;
      height: 160px;
    }
    .common-bot {
      position: relative;
      background: #fff;
      p {
        font-size: 14px;
        color: #333;
        line-height: 1.5;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 6;
        -webkit-box-orient: vertical;
      }
      span {
        position: absolute;
      }
      .type-1 {
        right: 10px;
        bottom: 10px;
      }
      .type-2 {
        right: 20px;
        bottom: 5px;
        color: #ff0000;
      }
    }
    .pro-tool {
      display: flex;
      height: 48px;
      align-items: center;
      justify-content: space-around;
      background-color: #f7f9fa;
      .pro-tool-item {
        flex: 1;
        line-height: 48px;
        font-size: 14px;
        color: #808080;
        cursor: pointer;
        text-align: center;
        &:hover {
          color: #1890ff;
        }

        &.z-del {
          &:hover {
            color: #f00;
          }
        }
      }

      .pro-tool-line {
        background-color: #e8e8e8;
        font-size: 20px;
        width: 1px;
        height: 22px;
        background-color: #e8e8e8;
      }
    }
  }
}
</style>

